/* Stick Videos-For-You section*/
(function () {
    $(document).ready(function() {
        "use strict";

        var $entry_content = $('.entry__body');
        var videoSelectors = [
            'iframe[src*="dailymotion.com"]',
            'iframe[src*="scripts.24.co.za"]',
            'iframe[src*="ultimedia.com"]',
            'iframe[src*="facebook.com\/plugins\/video.php"]',
            'iframe[src*="widgets.extratv.com"]',
            'iframe[src*="video.huffingtonpost.it"]',
            'iframe[src*="videos.huffingtonpost.de"]'
        ];

        /* youtube and vimeo supported by default*/
        $entry_content.fitVids({ 
        	customSelector: videoSelectors.join(', ')
        });
    });
}) ();